import React from 'react';
import Card from 'react-bootstrap/Card';

import Img1 from '../../img/products/equiposDePresion/EquiposPresionDiferencial/Hidroflow.png';
import Img2 from '../../img/products/equiposDePresion/EquiposPresionDiferencial/PresionDiferencial1.png';

const EquiposDePresionDiferencial = () => {
  const cardStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.6)', // fondo blanco semitransparente
    color: 'black',
  };

  const titleStyle = {
    color: 'red',
    textAlign: 'center',
    margin: 0,
  };

  const cardHeaderStyle = {
    backgroundColor: 'transparent',
    borderBottom: 'none',
  };

  const cardTextStyle = {
    textAlign: 'justify',
    color: 'black',
  };

  return (
    <div className="container mt-4">
      <div className="row g-4">
        <h3 className="mb-4" style={{ color: 'red', textAlign: 'center' }}>
          Equipos de Presión Diferencial
        </h3>

        <div className="col-12 col-md-6">
          <Card className="equal-card animate-fade-in-up shadow-sm" style={cardStyle}>
            <Card.Header style={cardHeaderStyle}>
              <h5 style={titleStyle}>Hidroflow</h5>
            </Card.Header>
            <div className="image-container">
              <img
                src={Img1}
                className="img-fluid img-hover-zoom"
                alt="Presion 1"
                style={{ objectFit: 'contain', height: '200px', width: '100%' }}
              />
            </div>
            <Card.Body>
              <Card.Text style={cardTextStyle}>
                El equipo de bombeo de agua Hidroflow es un sistema diseñado para mantener
                una presión constante en la red de distribución de agua, asegurando un
                suministro eficiente y confiable. Al ajustar la velocidad de las bombas
                según la demanda, se reduce el consumo de energía, lo que resulta en menores
                costos operativos. Mantienen una presión constante en toda la red de agua,
                mejorando el confort y la eficiencia del sistema.
              </Card.Text>
            </Card.Body>
          </Card>
        </div>

        <div className="col-12 col-md-6">
          <Card className="equal-card animate-fade-in-up shadow-sm" style={cardStyle}>
            <Card.Header style={cardHeaderStyle}>
              <h5 style={titleStyle}>Presión Diferencial</h5>
            </Card.Header>
            <div className="image-container">
              <img
                src={Img2}
                className="img-fluid img-hover-zoom"
                alt="Presion 2"
                style={{ objectFit: 'contain', height: '200px', width: '100%' }}
              />
            </div>
            <Card.Body>
              <Card.Text style={cardTextStyle}>
                El equipo de bombeo de agua de presión diferencial está diseñado para mantener
                una diferencia constante de presión entre dos puntos en un sistema de
                distribución de agua. Este tipo de equipo es especialmente útil en aplicaciones
                donde es necesario asegurar un flujo constante y equilibrado, posee sensores de
                presión que permiten monitorear la presión en dos puntos distintos del sistema
                y envían la información a un controlador central. Este dispositivo ajusta el
                funcionamiento de las bombas y válvulas para mantener la diferencia de presión
                establecida.
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default EquiposDePresionDiferencial;
